<template>
  <div class="security_settings">
    <div class="heading">
      您当前的账号：<strong>{{ username }}</strong>
    </div>
    <hr />
    <div class="main_content">
      <el-row>
        <el-col :span="2" style="text-align: center">
          <img class="securiy_icon" src="@/assets/icons/my/lock_red.png" alt="锁" />
        </el-col>
        <el-col :span="18">
          <h1>登录密码</h1>
          <h2>建议您定期更换密码，设置安全性高的密码可以使账号更安全</h2>
        </el-col>
        <el-col :span="4">
          <button class="edit_btn" @click="editPasswordVisible = true">修改</button>
        </el-col>
      </el-row>
      <!-- <hr /> -->
      <!-- <el-row>
        <el-col :span="2" style="text-align: center">
          <img class="phone_icon" src="@/assets/icons/my/mobile_red.png" alt="手机" />
        </el-col>
        <el-col :span="18">
          <h1>安全手机 {{ currentMobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}</h1>
          <h2>安全手机可以用于登录账号，重置密码或其他安全验证</h2>
        </el-col>
        <el-col :span="4">
          <router-link to="changemobile">
            <button class="edit_btn">更换</button>
          </router-link>
        </el-col>
      </el-row> -->
    </div>
    <hr />
    <el-row>
      <el-col :span="24">
        <div class="warning">
          <h1>安全服务提示</h1>
          <p>
            •
            确认您登录的是奇瑞官方商城网址，注意防范进入钓鱼网站，不要轻信各种即时通讯工具发送的商品或支付链接，谨防网购诈骗
          </p>
          <p>• 建议您安装杀毒软件，并定期更新操作系统等软件补丁，确保帐号及交易安全</p>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="修改密码"
      :visible.sync="editPasswordVisible"
      width="590px"
      v-loading="loading"
      :before-close="handleClose"
    >
      <div class="modal_content">
        <label> 原密码： </label>
        <custom-input
          placeholder="请输入原密码"
          class="content_input"
          type="password"
          v-model="resetPassForm.oldPassword"
          @blur="checkOldPassword"
          clearable
        >
          <span slot="errorMessage" v-if="resetPassFormErrors.oldPassword">
            {{ this.resetPassFormErrors.oldPassword }}
          </span>
        </custom-input>
        <label> 新的密码： </label>
        <custom-input
          placeholder="设置8至16位登录密码"
          class="content_input"
          type="password"
          v-model="resetPassForm.newPassword"
          @blur="checkNewPassword"
          clearable
        >
          <span slot="errorMessage" v-if="resetPassFormErrors.newPassword">
            {{ this.resetPassFormErrors.newPassword }}
          </span>
        </custom-input>
        <custom-input
          placeholder="请再次输入密码"
          class="content_input"
          type="password"
          v-model="resetPassForm.confirmPassword"
          @blur="checkConfirmPassword"
          clearable
        >
          <span slot="errorMessage" v-if="resetPassFormErrors.confirmPassword">
            {{ this.resetPassFormErrors.confirmPassword }}
          </span>
        </custom-input>
      </div>
      <span slot="footer">
        <button class="edit_btn cancel" @click="editPasswordVisible = false">取消</button>
        <button class="edit_btn confirm" @click="confirmChange">确认</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import changepwd from '@/api/changepassword'
// import login from '@/api/login'
import { encryptAes } from '@/lib/aes.js'
import personApi from '@api/personcenter'
import CustomInput from '@/components/business/login/CustomInput'
import login from '@/api/login'
import { removeStorage, getStorage } from '@/lib/utils'
export default {
  name: 'security-settings',
  data() {
    return {
      editPasswordVisible: false,
      resetPassForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      resetPassFormErrors: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      loading: false,
      currentMobile: '无',
      username: '无'
    }
  },
  components: {
    CustomInput
  },
  created() {
    personApi.getUserInfo().then((res) => {
      this.username = res.data.displayName
      this.currentMobile = res.data.mobile
    })
    // this.getKey()
    // this.$api.getUserDetailedInfo().then((res) => {
    //   if (res.status === 200) {
    //     const {
    //       data: { account }
    //     } = res
    //     if (account.mobile) {
    //       this.currentMobile = account.mobile
    //     }
    //     if (account.displayName) {
    //       this.username = account.displayName
    //     }
    //   }
    // })
  },
  methods: {
    // 退出登录
    logOut() {
      this.$feedback('密码修改成功，请重新登录')
      const token = getStorage('access_token')
      login.logout({ access_token: token }).then((res) => {
        if (res.status === 200) {
          removeStorage('access_token')
          removeStorage('userName')
          removeStorage('avatarUrl')
          removeStorage('userMobile')
          this.$router.push({ path: '/login' })
        } else {
          this.$feedback(res.message)
        }
      })
      removeStorage('access_token')
    },
    handleClose() {
      this.editPasswordVisible = false
    },
    // 验证旧密码
    checkOldPassword() {
      if (this.resetPassForm.oldPassword === '') {
        this.resetPassFormErrors.oldPassword = '请输入原密码'
      } else {
        this.resetPassFormErrors.oldPassword = ''
      }
    },

    // 验证新密码
    checkNewPassword() {
      if (this.resetPassForm.newPassword === '') {
        this.resetPassFormErrors.newPassword = '请输入新密码'
        return
      } else if (
        !/(?!^\d+$)(?!^[A-Z]+$)(?!^[a-z]+$)(?![`~!@#$%^&*()_-]+$)^[a-zA-Z\d`~!@#$%^&*()_-]{8,16}$/.test(
          this.resetPassForm.newPassword
        )
      ) {
        this.resetPassFormErrors.newPassword = '密码需为8-16位字母数字组合'
        return
      }
      this.resetPassFormErrors.newPassword = ''
    },

    // 验证确认密码
    checkConfirmPassword() {
      if (this.resetPassForm.confirmPassword === '') {
        this.resetPassFormErrors.confirmPassword = '确认密码不能为空'
        return
      } else if (this.resetPassForm.newPassword !== this.resetPassForm.confirmPassword) {
        this.resetPassFormErrors.confirmPassword = '两次输入的密码不一致'
        return
      }
      this.resetPassFormErrors.confirmPassword = ''
    },

    // getKey() { // 拿到加密密文
    //   const data = {
    //     mobile: '',
    //     algorithnm: 'aes'
    //   }
    //   changepwd
    //   .getKey(data).then((res) => {
    //     if (res.status === 200) {
    //       console.log('res', res)
    //     }
    //   })
    // },
    confirmChange() {
      this.checkOldPassword()
      this.checkNewPassword()
      this.checkConfirmPassword()
      const { resetPassFormErrors } = this
      let checkFlag = true
      Object.keys(resetPassFormErrors).forEach(function(key) {
        if (resetPassFormErrors[key] !== '') {
          checkFlag = false
        }
      })

      // 若错误信息表单内还有错误则阻止提交
      if (!checkFlag) {
        return
      }
      changepwd.getKey({ username: this.username }).then((res) => {
        const { random, iv } = res.data
        const newpasswordEncrypt = encryptAes(this.resetPassForm.newPassword + '|' + random, random, iv)
        const oldpasswordEncrypt = encryptAes(this.resetPassForm.oldPassword + '|' + random, random, iv)
        this.loading = true
        changepwd
          .changePass({
            oldPassword: oldpasswordEncrypt,
            newPassword: newpasswordEncrypt,
            username: this.currentMobile
          })
          .then((res) => {
            this.loading = false
            if (res.status === 200) {
              this.editPasswordVisible = false
              this.$feedback.success('登录密码修改成功')
              this.resetPassForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
              }
              // 退出登录
              this.logOut()
            } else {
              this.$feedback(res.message)
            }
          })
          .catch((error) => {
            this.loading = false
            this.$feedback(error.message)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.security_settings {
  width: 1085px;
  background: white;
  margin-bottom: 50px;
  box-shadow: 0px 1px 0px 0px rgba(224, 224, 224, 1);
  padding: 40px;
  box-sizing: border-box;
  .heading {
    font-size: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    letter-spacing: 1px;
    strong {
      font-weight: bold;
    }
  }
  hr {
    height: 2px;
    background: rgba(224, 224, 224, 1);
    margin: 38px 0;
    border: none;
  }
  .main_content {
    margin: 50px 0;
    h1 {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      letter-spacing: 2px;
    }
    h2 {
      font-size: 18px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 25px;
      margin-top: 5px;
    }
    hr {
      height: 2px;
      background: rgba(224, 224, 224, 1);
      margin: 54px 0;
      border: none;
    }
    .edit_btn {
      width: 133px;
      height: 40px;
      border: 1px solid #000;
      cursor: pointer;
      outline: none;
      background: white;
      font-size: 18px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
      margin-top: 10px;
    }
    .securiy_icon {
      width: 36px;
      height: 44px;
    }
    .phone_icon {
      width: 33px;
      height: 45px;
    }
  }
  .warning {
    background: rgba(249, 249, 249, 1);
    opacity: 0.757;
    margin-top: 100px;
    padding: 15px;
    h1 {
      font-size: 18px;
      font-weight: bold;
      color: rgba(153, 153, 153, 1);
      line-height: 25px;
      margin-bottom: 20px;
    }
    p {
      font-size: 18px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 25px;
    }
  }
  ::v-deep .el-dialog__header {
    padding: 15px 15px 10px;
    text-align: center;
  }
  .modal_content {
    padding: 0 90px;
    label {
      margin-top: 14px;
      box-sizing: border-box;
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
      display: block;
    }
    .content_input {
      width: 100%;
      height: 56px;
      margin: 0px auto 22px;
      display: inline-block;
    }
  }
  .edit_btn {
    width: 150px;
    height: 45px;
    cursor: pointer;
    outline: none;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    margin-top: 10px;
    margin-bottom: 59px;
    &.cancel {
      border: 1px solid rgba(51, 51, 51, 1);
      background: white;
      background: white;
      color: rgba(51, 51, 51, 1);
      margin-right: 30px;
    }
    &.confirm {
      border: none;
      background: rgba(31, 31, 31, 1);
      color: white;
    }
  }
  ::v-deep .el-dialog__footer {
    padding: 10px 15px 15px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
</style>
